/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

// eslint-disable-next-line prettier/prettier
import { Locale } from '@rbilabs/intl';
import {
  ca,
  cs,
  de,
  enGB,
  enNZ,
  enUS,
  es,
  fr,
  frCH,
  gl,
  id,
  it,
  ja,
  ko,
  nl,
  pl,
  pt,
  ro,
  ta,
  te,
  th,
  uk,
  zhCN,
  zhTW,
} from 'date-fns/locale';

export const LOCALE_DATE_FORMAT = {
  [Locale.ca_es]: {
    dateFormat: ca,
  },
  [Locale.cs_cz]: {
    dateFormat: cs,
  },
  [Locale.de_ch]: {
    dateFormat: frCH,
  },
  [Locale.de_de]: {
    dateFormat: de,
  },
  [Locale.de_aq]: {
    dateFormat: de,
  },
  [Locale.de_at]: {
    dateFormat: de,
  },
  [Locale.en_ch]: {
    dateFormat: frCH,
  },
  [Locale.en_de]: {
    dateFormat: de,
  },
  [Locale.en_gb]: {
    dateFormat: enGB,
  },
  [Locale.en_nl]: {
    dateFormat: enGB,
  },
  [Locale.en_nz]: {
    dateFormat: enNZ,
  },
  [Locale.en_us]: {
    dateFormat: enUS,
  },
  [Locale.en_za]: {
    dateFormat: enGB,
  },
  [Locale.en_es]: {
    dateFormat: es,
  },
  [Locale.en_aq]: {
    dateFormat: enUS,
  },
  [Locale.en_kr]: {
    dateFormat: ko,
  },
  [Locale.en_fr]: {
    dateFormat: fr,
  },
  [Locale.en_pt]: {
    dateFormat: pt,
  },
  [Locale.en_sg]: {
    dateFormat: enGB,
  },
  [Locale.en_cz]: {
    dateFormat: cs,
  },
  [Locale.en_pl]: {
    dateFormat: pl,
  },
  [Locale.en_at]: {
    dateFormat: enGB,
  },
  [Locale.en_ro]: {
    dateFormat: enGB,
  },
  [Locale.en_tw]: {
    dateFormat: enGB,
  },
  [Locale.en_my]: {
    dateFormat: enGB,
  },
  [Locale.en_id]: {
    dateFormat: enGB,
  },
  [Locale.en_th]: {
    dateFormat: enGB,
  },
  [Locale.en_ja]: {
    dateFormat: enGB,
  },
  [Locale.es_es]: {
    dateFormat: es,
  },
  [Locale.es_aq]: {
    dateFormat: es,
  },
  [Locale.pt_es]: {
    dateFormat: es,
  },
  [Locale.eu_es]: {
    dateFormat: es,
  },
  [Locale.fr_ch]: {
    dateFormat: frCH,
  },
  [Locale.fr_aq]: {
    dateFormat: fr,
  },
  [Locale.fr_fr]: {
    dateFormat: fr,
  },
  [Locale.gl_es]: {
    dateFormat: gl,
  },
  [Locale.hak_tw]: {
    dateFormat: zhTW,
  },
  [Locale.id_id]: {
    dateFormat: id,
  },
  [Locale.it_ch]: {
    dateFormat: frCH,
  },
  [Locale.it_aq]: {
    dateFormat: it,
  },
  [Locale.ja_ja]: {
    dateFormat: ja,
  },
  [Locale.jv_id]: {
    dateFormat: id,
  },
  [Locale.ko_kr]: {
    dateFormat: ko,
  },
  [Locale.ml_my]: {
    dateFormat: enGB,
  },
  [Locale.ms_sg]: {
    dateFormat: enGB,
  },
  [Locale.ms_my]: {
    dateFormat: enGB,
  },
  [Locale.nan_tw]: {
    dateFormat: zhTW,
  },
  [Locale.nl_nl]: {
    dateFormat: nl,
  },
  [Locale.nl_id]: {
    dateFormat: nl,
  },
  [Locale.pa_my]: {
    dateFormat: enGB,
  },
  [Locale.pl_pl]: {
    dateFormat: pl,
  },
  [Locale.pt_pt]: {
    dateFormat: pt,
  },
  [Locale.ro_ro]: {
    dateFormat: ro,
  },
  [Locale.ta_sg]: {
    dateFormat: ta,
  },
  [Locale.ta_my]: {
    dateFormat: ta,
  },
  [Locale.te_my]: {
    dateFormat: te,
  },
  [Locale.th_my]: {
    dateFormat: th,
  },
  [Locale.th_th]: {
    dateFormat: th,
  },
  [Locale.zh_sg]: {
    dateFormat: zhCN,
  },
  [Locale.zh_tw]: {
    dateFormat: zhTW,
  },
  [Locale.zh_my]: {
    dateFormat: zhCN,
  },
  [Locale.uk_cz]: {
    dateFormat: uk,
  },
  [Locale.uk_pl]: {
    dateFormat: uk,
  },
};
